package com.arena_web.data.api

import com.arena_web.data.dto.PricingDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

/**
 * Public endpoint — uses the unauthenticated default HTTP client. Pricing is
 * the same for every user and doesn't depend on the JWT.
 */
class PricingApi(private val client: HttpClient) {

    suspend fun getPricing(): ApiResponse<PricingDto> {
        return client.apiGet("v1/pricing")
    }
}
